/**
 * FlooraLogo — renders the SVG wordmark with fill driven by a CSS variable.
 * `color` defaults to white; pass "brand" to use var(--color-brand).
 */
export default function FlooraLogo({ color = 'white', height = 32, className = '' }) {
  const fill = color === 'brand' ? 'var(--color-brand)' : color;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 305.09 301.05"
      height={height}
      aria-label="Florra"
      className={className}
      style={{ display: 'block', fill }}
    >
      <path d="M229.19,300.52l-149.69.53C38.59,301.2.22,264.47.17,222.02L0,81.91C-.05,38.76,34.14-.07,78.32,0l151.46.23c42.45.06,75.32,39.03,75.31,80.4l-.04,139.66c-.01,41.33-33.1,78.74-75.86,80.23Z"/>
      <path style={{ fill: 'var(--floora-logo-inner, white)' }} d="M120.09,103.74c-34.35,5.6-53.64,41.03-69.46,70.01l-.02-57.94c0-31,29.22-67.79,66.54-67.84l146.71-.21c-1.33,32.32-26.3,56.02-58.37,56.01l-85.4-.04Z"/>
      <path style={{ fill: 'var(--floora-logo-inner, white)' }} d="M109.07,193.68c-26.11.27-49.47,13.32-58.4,36.52-2.1-25.16,4.42-49.17,20.68-67.88,11.26-12.96,26.99-23.03,44.41-23.03h61.97c10.86-.01,20.74,9.51,23.4,19.71,4.27,16.38-7.69,33.81-24.9,33.99l-67.16.7Z"/>
      <circle style={{ fill: 'var(--floora-logo-inner, white)' }} cx="83.26" cy="238.52" r="24.23"/>
    </svg>
  );
}
